import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { ElementRef, Injectable, Self, Inject } from '@angular/core';
import { tuiGetElementPoint } from '@taiga-ui/addon-editor/utils';
import { tuiTypedFromEvent, tuiPreventDefault, TuiDestroyService } from '@taiga-ui/cdk';
import * as i1 from 'rxjs';
import { Observable } from 'rxjs';
import { switchMap, map, takeUntil, startWith } from 'rxjs/operators';

class TuiPickerService extends Observable {
    constructor(destroy$, { nativeElement }, documentRef) {
        const point$ = tuiTypedFromEvent(nativeElement, `mousedown`).pipe(tuiPreventDefault(), switchMap(event => {
            const mouseMove$ = tuiTypedFromEvent(documentRef, `mousemove`).pipe(map(({ clientX, clientY }) => tuiGetElementPoint(clientX, clientY, nativeElement)), takeUntil(tuiTypedFromEvent(documentRef, `mouseup`)));
            return event.target === nativeElement
                ? mouseMove$.pipe(startWith(tuiGetElementPoint(event.clientX, event.clientY, nativeElement)))
                : mouseMove$;
        }), takeUntil(destroy$));
        super(subscriber => point$.subscribe(subscriber));
    }
}
TuiPickerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiPickerService, deps: [{ token: TuiDestroyService, self: true }, { token: ElementRef }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
TuiPickerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiPickerService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiPickerService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.Observable, decorators: [{
                    type: Self
                }, {
                    type: Inject,
                    args: [TuiDestroyService]
                }] }, { type: i0.ElementRef, decorators: [{
                    type: Inject,
                    args: [ElementRef]
                }] }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiPickerService };
